<script>
export default {
  name: 'CNSupport'
}
</script>

<template>
  <div>
    <img src="@assets/kefu.png" alt="logo" style="width:292px;" />
  </div>
</template>

<style scoped lang='less'>

</style>
